import { useState } from 'react';
import { ClientInscription } from '../api/inscription';
import type { FournisseurIdentite } from '../auth/identite';
import { adresseStripe } from '../domaine/inscription';
const clientDefaut = new ClientInscription();
/** /v0/abonnements désigne la diffusion d'événements, pas l'abonnement commercial. */
export function EcranAbonnement({ identite, administrateur, client = clientDefaut, rediriger = (url: string) => window.location.assign(url) }: {
  identite: FournisseurIdentite; administrateur: boolean; client?: ClientInscription; rediriger?: (url: string) => void;
}) {
  const [erreur, setErreur] = useState(''); const [occupe, setOccupe] = useState(false);
  return <section aria-label="Abonnement et factures"><h2>Abonnement et factures</h2>
    {!administrateur ? <p>La facturation est réservée à l’administrateur de l’entreprise.</p> : <>
      <p>Consultez l’état de votre abonnement et vos factures dans le portail de facturation.</p>
      <p>Le moyen de paiement est géré sur la page hébergée de Stripe. Aucune donnée de carte ni aucun IBAN ne passe par Ekera.</p>
      <button type="button" className="btn" disabled={occupe} onClick={() => {
        setErreur(''); setOccupe(true);
        void identite.enTetes().then(h => client.portail(h)).then(r => rediriger(adresseStripe(r.url, 'billing')))
          .catch(e => setErreur(e instanceof Error ? e.message : 'Le portail est indisponible.'))
          .finally(() => setOccupe(false));
      }}>Ouvrir le portail de facturation Stripe</button>
    </>}{erreur && <p role="alert">{erreur}</p>}
  </section>;
}
